<template>
  <div
    :class="{
      checkBox: true,
      disabled: isDisabled
    }"
    tabindex="0"
    role="checkbox"
    :aria-checked="checked"
    @click="() => (isDisabled ? null : onSelect(id))"
  >
    <span class="checkBoxIcon">
      <WrongIcon v-if="shouldShowX" />
      <CorrectIcon v-if="shouldShowCheck" />
      <SelectedIcon v-if="checked && !shouldShowX && !shouldShowCheck" />
      <div
        v-if="isHinted && !checked && !shouldShowX && !shouldShowCheck"
        id="hintBackground"
      ></div>
    </span>
    <span :id="`label-${id}`" :class="labelClass">
      {{ label }}
    </span>
  </div>
</template>

<script>
import WrongIcon from '../icons/SolidSquareRedX.vue';
import CorrectIcon from '../icons/SolidSquareGreenCheckMark.vue';
import SelectedIcon from '../icons/BlueSelected.vue';

export default {
  components: {
    WrongIcon,
    CorrectIcon,
    SelectedIcon
  },

  props: {
    id: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    isCorrect: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    isSubmitted: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isHinted: {
      type: Boolean,
      default: false
    },
    numOfAttempts: {
      type: Number,
      default: 0
    },
    onSelect: {
      type: Function,
      default: () => null
    },
    showError: {
      type: Boolean,
      default: false
    },
    showSuccess: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    shouldShowCheck() {
      return this.checked && (this.isSubmitted || this.showSuccess) && this.isCorrect;
    },
    shouldShowX() {
      return this.checked && (this.isSubmitted || this.showError) && !this.isCorrect;
    },
    labelClass() {
      return {
        label: true,
        labelHinted: this.isHinted,
        labelSelected: this.checked || this.isHinted
      };
    }
  }
};
</script>

<style scoped lang="scss">
.checkBox {
  align-items: center;
  border: 1px solid #979797;
  cursor: pointer;
  display: flex;
  padding: 15px 30px;
  width: 100%;
  box-sizing: border-box;
}

.checkBoxIcon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  width: 2.5rem;
  border: 2px solid #808080;

  svg {
    height: 95%;
    width: 95%;
  }
}

.disabled {
  span {
    cursor: not-allowed !important;
  }
}

.label {
  padding-left: 30px;
  font-size: 24px;
}

.labelHinted {
  color: #42a854;
}

.labelSelected {
  font-weight: bolder;
}

#hintBackground {
  background: #42bd56;
  border-radius: 5px;
  height: 82%;
  width: 82%;
}
</style>
